/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/** @jsx jsx */
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { css, jsx } from "@emotion/core";
import SidebarTemplate from "components/templates/SidebarTemplate";
import BlockUI from "components/molecules/BlockUi";
import FormContents from "components/atoms/Form/FormContents";
import Timeline, { DateHeader, SidebarHeader, TimelineHeaders } from "../ReactCalendarTimeline/index";
import { utilityColor, grayScale, textFontSize } from "components/styles";
import ContextMenuShift from "components/molecules/ContextMenu/ContextMenuShift";
import {
  TimelineItemBase,
  ItemContext,
  GetItemsProps,
  GetResizeProps,
  ItemRendererGetResizePropsReturnType,
  TimelineGroupCustom
} from "types/react-calendar-timeline";
import ModalRegisterShift from "./Modals/ModalRegisterShift";
import Modal from "components/molecules/Modal";
import { dailyShiftContext, useInitialState } from "./contextHook";
import Filters from "./Filters";
import IconLabelButton from "components/molecules/IconLabelButton";
import { photoPath } from "hooks/usePhotoPath";
import "../ReactCalendarTimeline/lib/Timeline.scss";
import PhotoFrame from "components/molecules/PhotoFrame";
import Icon from "components/atoms/Icon";
import ReactTooltip from "react-tooltip";
import FormTitle from "components/atoms/Form/FormTitle";
import ConfirmModal from "components/organismos/ConfirmModal";
import TextTooltip from "components/molecules/TextTooltip";
import FormPadding from "components/atoms/Form/FormPadding";
import FormHeader from "components/templates/FormHeader";
const isMacbook = window.matchMedia("(max-width: 1440px)").matches;
const DailyShift: React.FC = () => {
  const contextInitialState = useInitialState();

  const {
    remote,
    setRemote,
    isLoading,
    openConfirmModal,
    setOpenConfirmModal,
    openDeleteModal,
    setOpenDeleteModal,
    dailyShift,
    filters: { submitShiftLockout },
    calendar: {
      items,
      deleteItem,
      groups,
      selectedItem,
      setSelectedItem,
      selectedItemIdArr,
      setSelectedItemIdArr,
      defaultTimeStart,
      defaultTimeEnd,
      sidebarName,
      sidebarType,
      sidebarHeaderWidth,
      sidebarHeaderRightWidth,
      onTimeChange,
      onItemMove,
      onItemSelect,
      onItemClick,
      onCanvasClick,
      onItemResize,
      moveResizeValidator,
      onClickAttendStampList,
    },
    contextMenu: {
      isPerformanceMenuVisible,
      setPerformanceMenuVisible,
      isItemMenuVisible,
      setItemMenuVisible,
      isTimelineMenuVisible,
      setTimelineMenuVisible,
      contextMenuRef,
      contextMenuX,
      contextMenuY,
      menuTimelineButtons,
      menuPerformanceButtons,
      menuItemButtons,
    },
    shiftPattern: { openShiftPatternModal }
  } = contextInitialState;

  let bodyNode = document.body as HTMLBodyElement;

  const prefix = 'dailyShift';
  const prefixLeft = 'dailyShift_left';
  const prefixRight = 'dailyShift_right';

  const highlightAction = sessionStorage.getItem('highlightAction') || false;
  const highlightIndex = sessionStorage.getItem('highlightIndex') || '';
  const elmnt = document.getElementById(prefix + '_row_' + highlightIndex);
  const elmntLeft = document.getElementById(prefixLeft + '_' + highlightIndex);
  const elmntRight = document.getElementById(prefixRight + '_' + highlightIndex);

  useEffect(() => {
    if (highlightAction === 'true') {
      if (elmnt && elmntLeft && elmntRight) {
        elmnt.classList.add("hightlight");
        elmntLeft.classList.add("hightlight");
        elmntRight.classList.add("hightlight");
        elmntRight.scrollIntoView({ block: 'center' });

        setTimeout(() => {
          elmnt.classList.remove("hightlight"); 
          elmntLeft.classList.remove("hightlight"); 
          elmntRight.classList.remove("hightlight"); 

          sessionStorage.setItem('highlightAction', 'false');
          sessionStorage.setItem('highlightIndex', '');
        }, 3000);
      }
    }
  }, [elmnt, elmntLeft, elmntRight, highlightAction]);

  return (
    <SidebarTemplate pageTitle="シフト管理">
      <BlockUI blocking={isLoading}>
        <dailyShiftContext.Provider value={contextInitialState}>
          <FormHeader title="日次" customStyle={css({ marginTop: '0'})} />
          <FormContents customStyle={css({ marginTop: '60px' })}>
            <Filters />
            {
              isPerformanceMenuVisible &&
              createPortal(
                <div className="contextMenu">
                  <ContextMenuShift
                    buttons={menuPerformanceButtons}
                    pageX={contextMenuX}
                    pageY={contextMenuY}
                    parentRef={contextMenuRef}
                    setIsComponentVisible={setPerformanceMenuVisible}
                  />
                </div>,
                bodyNode
              )
            }
            {
              isItemMenuVisible &&
              createPortal(
                <div className="contextMenu">
                  <ContextMenuShift
                    buttons={menuItemButtons}
                    pageX={contextMenuX}
                    pageY={contextMenuY}
                    parentRef={contextMenuRef}
                    setIsComponentVisible={setItemMenuVisible}
                  />
                </div>,
                bodyNode
              )
            }
            {
              isTimelineMenuVisible &&
              createPortal(
                <div className="contextMenu">
                  <ContextMenuShift
                    buttons={menuTimelineButtons}
                    pageX={contextMenuX}
                    pageY={contextMenuY}
                    parentRef={contextMenuRef}
                    setIsComponentVisible={setTimelineMenuVisible}
                  />
                </div>,
                bodyNode
              )
            }
            <FormPadding>
              {
                defaultTimeStart && defaultTimeEnd && groups.length > 0 && (
                  <Timeline
                    lineHeight={48}
                    itemHeightRatio={0.5}
                    rightSidebarWidth={sidebarHeaderRightWidth}
                    sidebarWidth={sidebarHeaderWidth}
                    groups={groups}
                    items={items}
                    defaultTimeStart={defaultTimeStart}
                    defaultTimeEnd={defaultTimeEnd}
                    // visibleTimeStart={defaultTimeStart.valueOf()}
                    // visibleTimeEnd={defaultTimeEnd.valueOf()}
                    minZoom={12 * 60 * 60 * 1000}
                    maxZoom={12 * 60 * 60 * 1000}
                    canChangeGroup={false}
                    onTimeChange={onTimeChange}
                    onItemMove={onItemMove}
                    onItemResize={onItemResize}
                    moveResizeValidator={moveResizeValidator}
                    onItemDeselect={(e: React.SyntheticEvent) => {
                      setSelectedItem({} as TimelineItemBase<number>); //reset
                    }}
                    selected={selectedItemIdArr}
                    onItemSelect={onItemSelect}
                    onItemClick={onItemClick}
                    onCanvasClick={onCanvasClick}
                    groupRenderer={(groupObj: { group: TimelineGroupCustom; isRightSidebar: any }) => {
                      const { group, isRightSidebar } = groupObj;
                      return isRightSidebar ? (
                        <div 
                          className="rct-sidebar-row__block" 
                          style={{ textAlign: "center", width: isMacbook? '78px' :'60px' }}
                        >
                          <div className="rct-sidebar-row__block-child">
                            {group.rightData && group.rightData[0]}
                          </div>
                          <div 
                            className="rct-sidebar-row__block-child" 
                            style={{ borderTop: `1px solid ${grayScale.gray20}` }}
                          >
                            {group.rightData && group.rightData[1]}
                          </div>
                          <div 
                            className="rct-sidebar-row__block-child" 
                            style={{ borderTop: `1px solid ${grayScale.gray20}` }}
                          >
                            {group.rightData && group.rightData[2]}
                          </div>
                        </div>
                      ) : (
                        <div 
                          className="rct-sidebar-group" 
                          style={{ display: "flex" }}
                        >
                          <div
                            className="rct-sidebar-row__block"
                            style={{
                              width: `${sidebarName}px`,
                              padding: "10px 0 10px 20px",
                              whiteSpace: "pre-wrap",
                              lineHeight: "22px",
                              alignSelf: "center",
                              fontSize: textFontSize.sm,
                            }}
                          >
                            <div 
                              className="d-flex" 
                              style={{ alignItems: "center" }}
                            >
                              <div
                                style={{
                                  borderRadius: "50%",
                                  overflow: "hidden",
                                  height: "55px",
                                  width: "55px"
                                }}
                              >
                                <PhotoFrame 
                                  src={photoPath(group)} 
                                  size="55px" 
                                  isCircle={true} 
                                  onErrorIconColor="black" 
                                />
                              </div>
                                {
                                  !group.isSupportStaff && (
                                    <IconLabelButton
                                      onClick={() => {
                                        onClickAttendStampList(group);
                                      }}
                                      text="詳細"
                                      isIcon={false}
                                    />
                                  )
                                }
                              </div>
                              <div css={css`
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                              `}>
                                <TextTooltip 
                                  text={group.employmentName} 
                                  textDis={(
                                    <span>{group.employmentName}</span>
                                  )}
                                  customCss={css({
                                  textOverflow: 'ellipsis',
                                  overflow: 'hidden',
                                  maxWidth: '140px',
                                  whiteSpace: 'nowrap',
                                  display: 'inline-block',
                                  margin: '0px auto'
                                  })}
                                />
                              </div>
                              <div 
                                css={css`
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                `}
                              >
                              <TextTooltip 
                                text={group.staffName} 
                                textDis={(
                                  <span>{group.staffName}</span>
                                )}
                                customCss={css({
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                maxWidth: '140px',
                                whiteSpace: 'nowrap',
                                display: 'inline-block',
                                margin: '0px auto'
                                })}
                              />
                            </div>
                          </div>
                            {/* <div
                            className="rct-sidebar-row__block"
                            style={{ width: `${sidebarSupport}px`, borderLeft: `1px solid ${grayScale.gray20}` }}
                            ></div> */}
                          <div
                            className="rct-sidebar-row__block"
                            style={{
                              width: `${sidebarType}px`,
                              textAlign: "center",
                              borderLeft: `1px solid ${grayScale.gray20}`,
                              borderRight: `1px solid ${grayScale.gray20}`
                            }}
                          >
                            <div className="rct-sidebar-row__block-child">希望</div>
                            <div 
                              className="rct-sidebar-row__block-child" 
                              style={{ borderTop: `1px solid ${grayScale.gray20}` }}
                            >
                              シフト
                            </div>
                            <div 
                              className="rct-sidebar-row__block-child" 
                              style={{ borderTop: `1px solid ${grayScale.gray20}` }}
                            >
                              {
                                group.dateInfo[0].achievementErrorMessage && (
                                  <div
                                    data-tip={group.dateInfo[0].achievementErrorMessage}
                                    data-for={`error-${group.staffCode}`}
                                    css={css({
                                      width: "fit-content",
                                      display: "inline-flex",
                                      paddingRight: '3px'
                                    })}
                                  >
                                    <Icon 
                                      type="remove" 
                                      color="" 
                                      verticalAlign="text-bottom" 
                                      size="18px" 
                                    />
                                    <ReactTooltip 
                                      html={true} 
                                      id={`error-${group.staffCode}`} 
                                    />
                                  </div>
                                )
                              }
                              {
                                group.dateInfo[0].isAchievementConfirm && (
                                  <div
                                    css={css({
                                      width: "fit-content",
                                      display: "inline-flex",
                                      paddingRight: '3px'
                                    })}
                                  >
                                    <Icon 
                                      type="singlecheckRounded" 
                                      color="#34a659" 
                                      verticalAlign="text-bottom" 
                                      size="18px" 
                                    />
                                  </div>
                                )
                              }
                              {
                                group.dateInfo[0].achievementAlertMessage && (
                                  <div
                                    data-tip={group.dateInfo[0].achievementAlertMessage}
                                    data-for={`alert-${group.staffCode}`}
                                    css={css({
                                      width: "fit-content",
                                      display: "inline-flex",
                                      paddingRight: '3px'
                                    })}
                                  >
                                    <Icon 
                                      type="warning" 
                                      color={utilityColor.yellow} 
                                      verticalAlign="text-bottom" 
                                      size="18px" 
                                    />
                                    <ReactTooltip 
                                      html={true} 
                                      id={`alert-${group.staffCode}`} 
                                    />
                                  </div>
                                )
                              }
                              実績
                            </div>
                          </div>
                        </div>
                      );
                    }}
                    itemRenderer={(itemRenderer: {
                      item: TimelineItemBase<number>;
                      itemContext: ItemContext;
                      getItemProps: (props: GetItemsProps) => {};
                      getItemBreaktimeProps: (props: GetItemsProps) => {};
                      getResizeProps: (propsOverride?: GetResizeProps) => ItemRendererGetResizePropsReturnType;
                    }) => {
                      const { item, itemContext, getItemProps, getResizeProps, getItemBreaktimeProps } = itemRenderer;
                      const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
                      return (
                        <div
                          {
                            ...getItemProps({
                              ...item.itemProps,
                              style: {
                                color: "white",
                                borderStyle: "solid",
                                borderWidth: 1,
                                borderRadius: 4,
                                borderLeftWidth: itemContext.selected ? 1 : 0,
                                borderRightWidth: itemContext.selected ? 1 : 1,
                                ...item.itemProps?.style
                              }
                            })
                          }
                        >
                          {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}
                          <div
                            style={{
                              color: item.holidayForecolor ? String(item.holidayForecolor) : 'white',
                              background: item.holidayBgcolor ? String(item.holidayBgcolor) : 'none',
                              height: itemContext.dimensions.height,
                              overflow: "hidden",
                              paddingLeft: 3,
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              position: "relative"
                            }}
                          >
                            {item.title}
                            {
                              item.breaks && item.breaks.map((br, i) => {
                                return (
                                  <div 
                                    key={i} 
                                    {
                                      ...getItemBreaktimeProps({ style: { background: "white" }, breakId: i })
                                    }
                                  ></div>
                                )
                              })
                            }
                          </div>
                          {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                        </div>
                      );
                    }}
                  >
                    <TimelineHeaders
                      className="sticky"
                      calendarHeaderStyle={{ color: grayScale.gray60 }}
                      style={{ 
                        background: utilityColor.white, 
                        top: 0, 
                        zIndex: 101, 
                        position: 'sticky' 
                      }}
                    >
                      <SidebarHeader>
                        {
                          ({ getRootProps }) => {
                            return (
                              <div {...getRootProps()} style={{ display: "flex" }}>
                                <div
                                  className="rct-sidebar-row__block"
                                  style={{ 
                                    width: `${sidebarName}px`, 
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center", 
                                    fontSize: "14px" 
                                  }}
                                >
                                  氏名
                                </div>
                                {/* <div
                                  className="rct-sidebar-row__block"
                                  style={{
                                    width: `${sidebarSupport}px`,
                                    borderLeft: `1px solid ${grayScale.gray20}`,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "14px",
                                  }}
                                >
                                  休暇
                                </div> */}
                                <div
                                  className="rct-sidebar-row__block"
                                  style={{
                                    width: `${sidebarType}px`,
                                    borderLeft: `1px solid ${grayScale.gray20}`,
                                    borderRight: `1px solid ${grayScale.gray20}`
                                  }}
                                ></div>
                              </div>
                            );
                          }
                        }
                      </SidebarHeader>
                      <SidebarHeader variant="right">
                        {
                          ({ getRootProps, data }) => {
                            return (
                              <div
                                {...getRootProps()}
                                style={{
                                  // maxWidth: `${sidebarHeaderRightWidth}px`,
                                  width: `${sidebarHeaderRightWidth - 18}px`,
                                  // marginLeft: '19px',
                                  // width: "60px",
                                  textAlign: "center",
                                  lineHeight: "22px",
                                  fontSize: "12px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  right: isMacbook?'15px':'',
                                  background: '#F2F8FC',
                                }}
                                className="header-lastchild-daily"
                              >
                                <div 
                                  style={{ 
                                    borderBottom: `1px solid ${grayScale.gray20}`, 
                                    height: "100%",
                                    width: isMacbook? '78px' :''
                                  }}
                                >
                                  時間 (h)
                                </div>
                                <div style={{ height: "100%", width: isMacbook? '78px' :'' }}>当日計</div>
                              </div>
                            );
                          }
                        }
                      </SidebarHeader>
                      <DateHeader 
                        unit="hour" 
                        labelFormat="H" 
                        height={47} 
                        style={{ color: grayScale.gray03 }} 
                      />
                    </TimelineHeaders>
                  </Timeline>
                )
              }
            </FormPadding>
          </FormContents>

          {/* Confirm shift modal */}
          <Modal
            open={openConfirmModal}
            closeHandler={() => {
              setOpenConfirmModal(false);
            }}
            title="シフトの確定"
            note={dailyShift?.isShiftConfirm ? "シフト確定を解除します。よろしいですか？" : "シフトを確定します。よろしいですか？"}
            submitText={dailyShift?.isShiftConfirm ? "解除する" : "確定する"}
            onSubmit={submitShiftLockout}
            closeText="キャンセル"
            typeSubmit={(dailyShift?.isShiftConfirm ? "シフト確定を解除します。よろしいですか？" : "シフトを確定します。よろしいですか？") === 'シフト確定を解除します。よろしいですか？' ? 'reject' : 'confirm'}
          />

          {/* Confirm delete modal */}
          <Modal
            open={openDeleteModal}
            closeHandler={() => {
              setOpenDeleteModal(false);
            }}
            title="シフトの削除"
            note="シフトを削除します。よろしいですか？"
            submitText="削除する"
            onSubmit={() => {
              deleteItem(selectedItem?.idToString!);
              setOpenDeleteModal(false);
            }}
            closeText="キャンセル"
            typeSubmit={'reject'}
          />
          {openShiftPatternModal && <ModalRegisterShift />}
        </dailyShiftContext.Provider>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default DailyShift;
